import { useEffect, useState } from 'react';

import { ServicesButtonsListItem } from '@/components/blocks/services/buttons/item';

import { listServices } from '@/styles/components/lists.module.scss';

export const ServicesButtonsList = () => {
  // Function to check if the code is running in the browser
  const isBrowser = typeof window !== 'undefined';

  // Function to check if the view is mobile
  const isMobileView = () => {
    return isBrowser && window.innerWidth <= 767; // Adjust the breakpoint as needed
  };

  const [isActive, setActive] = useState(isMobileView());

  // Update the isActive state based on the current view
  useEffect(() => {
    const handleResize = () => {
      setActive(isMobileView());
    };

    // Add event listener for window resize only if running in the browser
    if (isBrowser) {
      window.addEventListener('resize', handleResize);

      // Clean up the event listener when the component is unmounted
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, [isBrowser]);

  return (
    <ul className={listServices}>
      <ServicesButtonsListItem
        title="8-Hour Private Charter"
        to="/services/8-hour-private-party-boat-charter"
        duration={
          <>
            8 <small>Hr</small>
          </>
        }
        price="$1,024+"
        subtitle={
          <>
            &middot; 12 Guests &middot; Captained &middot;
            Any Day
          </>
        }
      />
      <ServicesButtonsListItem
        title="6-Hour Private Charter"
        to="/services/6-hour-private-party-boat-charter"
        duration={
          <>
            6 <small>Hr</small>
          </>
        }
        price="$924+"
        subtitle={
          <>
            {' '}
            &middot; 12 Guests &middot; Captained &middot;
            Any Day
          </>
        }
      />
      <ServicesButtonsListItem
        title="4-Hour Private Charter"
        to="/services/4-hour-private-party-boat-charter"
        duration={
          <>
            4 <small>Hr</small>
          </>
        }
        price="$824+"
        subtitle={
          <>
            {' '}
            &middot; 12 Guests &middot; Captained &middot;
            Any Day
          </>
        }
      />
      <ServicesButtonsListItem
        title="3 hr Sunset Private Charter"
        to="/services/sunset-private-party-boat-charter"
        displayTitle="Sunset Private Charter"
        duration={
          <>
            3 <small>Hr</small>
          </>
        }
        price="$549+"
        subtitle={
          <>
            {' '}
            &middot; 12 Guests &middot;Captained &middot;
            Any Day
          </>
        }
      />
      <ServicesButtonsListItem
        title="3- Hour Wave Rave Charter"
        to="/services/3-hour-wave-rave-djd-nightime-party-boat-charter"
        duration={
          <>
            3 <small>Hr</small>
          </>
        }
        price="$825+"
        subtitle={
          <>
            {' '}
            &middot; 12 Guests &middot;Captained &middot;
            Any Day
          </>
        }
      />

      <ServicesButtonsListItem
        title="Private Snorkeling Charters"
        to="/services/private-snorkeling-charters-st-petersburg"
        duration={
          <>
            4 <small>Hr</small>
          </>
        }
        price="$749+"
        subtitle={
          <>
            {' '}
            &middot; 6 Guests &middot; Captained &middot;
            Any Day
          </>
        }
      />
      <ServicesButtonsListItem
        title="Large Group Boat Charter"
        to="/services/large-group-charter-boat"
        duration={
          <>
            3-8<small style={{ left: '3rem' }}>H</small>
          </>
        }
        price="TBA"
        subtitle={
          <>
            {' '}
            &middot; Up to 30 Guests &middot; Captained &middot;
            Any Day
          </>
        }
      />
    </ul>
  );
};
